import React from "react";
import { Box } from "../design-system";
import { colors } from "../design-system/colors";
import { USAGE_TAB } from "./constants/accountText";
import UsageRow from "./UsageRow";
import { UsageLimitsResponse } from "../../types/user";
import {
  getStoragePct,
  getTranscriptPct,
  getExportsPct,
  getStorageLabel,
  getTranscriptLabel,
  getExportsLabel,
} from "./utils/usageFormatters";

interface UsageContentProps {
  usage: UsageLimitsResponse | null;
  loadError: boolean;
}

const UsageContent = ({ usage, loadError }: UsageContentProps) => {
  if (loadError) {
    return (
      <Box sx={{ color: colors.neutral[600], fontFamily: "Outfit, sans-serif" }}>
        {USAGE_TAB.LOADING_ERROR}
      </Box>
    );
  }

  const storagePct = getStoragePct(usage);
  const transcriptPct = getTranscriptPct(usage);
  const exportsPct = getExportsPct(usage);

  const storageLabel = getStorageLabel(usage);
  const transcriptLabel = getTranscriptLabel(usage);
  const exportsLabel = getExportsLabel(usage);

  return (
    <>
      <UsageRow label={USAGE_TAB.STORAGE_LABEL} usedLabel={storageLabel} pct={storagePct} />
      <UsageRow label={USAGE_TAB.TRANSCRIPTION_LABEL} usedLabel={transcriptLabel} pct={transcriptPct} />
      <UsageRow label={USAGE_TAB.EXPORTS_LABEL} usedLabel={exportsLabel} pct={exportsPct} />
    </>
  );
};

export default UsageContent;
